<template>
  <div class="my-info-page">
    <SubPageHeader title="个人中心" />

    <div class="content">
      <div class="avatar-row">
        <el-avatar shape="circle" class="profile-avatar" :src="avatarSrc" />
      </div>

      <div class="info-list">
        <div v-for="item in infoItems" :key="item.label" class="info-item">
          <div class="info-label">{{ item.label }}:</div>
          <div class="info-value">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserProfile } from '@/api';
import { formatDateOnly, getCachedUserProfile, setCachedUserProfile } from '@/utils/profile';
import femaleAvatar from '@/assets/img/mine/female.png';
import maleAvatar from '@/assets/img/mine/male.png';
import SubPageHeader from '../component/SubPageHeader.vue';

export default {
  name: 'MyInfoPage',
  components: {
    SubPageHeader
  },
  data() {
    return {
      profileData: getCachedUserProfile()
    };
  },
  computed: {
    info() {
      return this.profileData?.info || {};
    },
    avatarSrc() {
      return this.info.sex_text === '女' ? femaleAvatar : maleAvatar;
    },
    infoItems() {
      return [
        { label: '党员姓名', value: this.info.real_name || '--' },
        { label: '性别', value: this.info.sex_text || '--' },
        { label: '民族', value: this.info.nation || this.info.nation_text || '--' },
        { label: '籍贯', value: this.info.originate || '--' },
        { label: '手机号', value: this.info.mobile || '--' },
        { label: '出生年月日', value: formatDateOnly(this.info.birthday) },
        { label: '学历', value: this.info.ducation_level_name || this.info.education_text || '--' },
        { label: '党内职务', value: this.info.position_name || '--' },
        { label: '入党日期', value: formatDateOnly(this.info.join_at) },
        { label: '转正日期', value: formatDateOnly(this.info.turn_forward_at) },
        { label: '政治面貌', value: this.info.political_status_text || '--' },
        { label: '所属党组织', value: this.info.org_name || '--' }
      ];
    }
  },
  mounted() {
    this.fetchUserProfile();
  },
  methods: {
    async fetchUserProfile() {
      try {
        const res = await getUserProfile();
        const payload = res?.data || null;
        if (payload) {
          this.profileData = payload;
          setCachedUserProfile(payload);
        }
      } catch (error) {
        // 错误提示已在全局请求拦截器中统一处理
      }
    }
  }
};
</script>

<style scoped lang="scss">
.my-info-page {
  min-height: 100vh;
  background: #ffffff;
}

.content {
  padding: 3.07692vw 0 6.15385vw;
}

.avatar-row {
  padding: 3.07692vw 0 5.12821vw 5.12821vw;
  background: #ffffff;
}

.profile-avatar {
  width: 20vw !important;
  height: 20vw !important;
  border: 1vw solid #F7F7F7;
}

.info-list {
  background: #ffffff;
}

.info-item {
  padding: 4.61538vw 5.12821vw 3.84615vw;
  border-bottom: 0.25641vw solid #ececec;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 4.61538vw;
  font-weight: 700;
  color: #000;
}

.info-value {
  margin-top: 2.05128vw;
  font-size: 4.35897vw;
  color: #000;
  line-height: 1.5;
}
</style>
